import React from 'react';

/**
 * Main layout component that wraps all pages and includes the LeftNav and TopNav
 * @param {Object} props - The component props
 * @returns {JSX.Element} The layout component
 */
const AdminLayout = ({ children }) => {

  return (
      <div className="flex flex-row flex-1 overflow-hidden h-full">
        {/* Main Content */}
        <div className="flex-1 font-Poppins overflow-auto">
          {children}
        </div>
      </div>
  );
};

export default AdminLayout;